import React, { Component } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@material-ui/core";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import NewsImageUpload from "../last-news/NewsImageUpload";
import CloseButton from "./CloseButton";
import { handleCreateNews } from "../../actions/news";
import moment from "moment";
import { uploadMedia } from "../../utils/api";
import "moment/locale/en-au";

class AddNewsModal extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
  };

  state = {
    title_ar: "",
    details_ar: "",
    title_en: "",
    details_en: "",
    submitDisabled: true,
    files: [],
    imagePath: "",
    imageLoading: true,
  };

  handleSubmitDisabled = () => {
    const { title_ar, details_ar, title_en, details_en, submitDisabled, imagePath } = this.state;
    if (!title_ar || !title_en || !imagePath || (!details_ar && !details_en && !submitDisabled))
      this.setState({ submitDisabled: true });
    if (title_ar && details_ar && title_en && details_en && imagePath && submitDisabled)
      this.setState({ submitDisabled: false });
  };
  handleTitleArChange = (e) => {
    this.setState({ title_ar: e.target.value }, this.handleSubmitDisabled);
  };
  handleDetailsArChange = (e) => {
    this.setState({ details_ar: e.target.value }, this.handleSubmitDisabled);
  };
  handleTitleEnChange = (e) => {
    this.setState({ title_en: e.target.value }, this.handleSubmitDisabled);
  };
  handleDetailsEnChange = (e) => {
    this.setState({ details_en: e.target.value }, this.handleSubmitDisabled);
  };
  handleSetFiles = (files) => {
    this.setState(
      { files },
      () => {
        const { files } = this.state;
        const form = new FormData();
        form.append("file", files[0]);
        form.append("mime_type", "image");

        uploadMedia(form)
          .then((res) => res.json())
          .then((res) => {
            this.setState({ imagePath: res.path, imageLoading: false });
          });
      },
      this.handleSubmitDisabled
    );
  };

  handleSubmit = () => {
    const { createNews, handleClose } = this.props;
    const { title_ar, details_ar, title_en, details_en, imagePath } = this.state;
    const data = {
      title: {
        ar: title_ar,
        en: title_en,
      },
      content: {
        ar: details_ar,
        en: details_en,
      },
      published_at: moment().locale("en").format("YYYY-MM-DD HH:mm:ss"),
      image: imagePath,
    };
    createNews(data);
    handleClose();
  };

  render() {
    const { open, handleClose } = this.props;
    const { title_ar, details_ar, title_en, details_en, submitDisabled, files, imageLoading } = this.state;

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        classes={{
          paper: "dialog",
        }}
        aria-labelledby="responsive-dialog-title"
      >
        <CloseButton handleClose={handleClose} />
        <DialogTitle id="responsive-dialog-title" className="text-center">
          إضافة خبر جديد
        </DialogTitle>
        <DialogContent>
          <div className="form-group">
            <NewsImageUpload files={files} setFiles={this.handleSetFiles} loading={imageLoading} />
          </div>
          <div className="form-group">
            <TextField
              type="text"
              placeholder="عنوان الخبر بالعربية"
              className="form-control"
              required
              value={title_ar}
              onChange={this.handleTitleArChange}
              variant="outlined"
              size="small"
            />
          </div>
          <div className="form-group">
            <TextField
              type="text"
              placeholder="عنوان الخبر بالانجليزية"
              className="form-control"
              required
              value={title_en}
              onChange={this.handleTitleEnChange}
              variant="outlined"
              size="small"
            />
          </div>
          <div className="form-group">
            <TextField
              rows={3}
              placeholder="النص بالعربية"
              fullWidth
              required
              value={details_ar}
              onChange={this.handleDetailsArChange}
              variant="outlined"
              size="small"
              multiline
            />
          </div>
          <div className="form-group">
            <TextField
              rows={3}
              placeholder="النص بالانجليزية"
              fullWidth
              required
              value={details_en}
              onChange={this.handleDetailsEnChange}
              variant="outlined"
              size="small"
              multiline
            />
          </div>
        </DialogContent>
        <DialogActions className="justify-content-center align-items-center">
          <Button
            onClick={this.handleSubmit}
            color="primary"
            variant="contained"
            className="dialog__btn"
            disabled={submitDisabled}
          >
            حفظ
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  createNews: (data) => dispatch(handleCreateNews(data)),
});

export default connect(null, mapDispatchToProps)(AddNewsModal);
